// extracted by mini-css-extract-plugin
export default {"wrapper_content":"styles_wrapper_content__UDHke","wrapper":"styles_wrapper__DNqiV","text":"styles_text__OtHil"};